import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient, useMutation} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {QueryKeyName, deleteAction} from '../../common/backend'
import {FEATURE_NAMESPACE} from '../../consts'
import {usePlantUpmId} from '../usePlantUpmIdContext'

export const useDeleteAction = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const plantId = usePlantUpmId()
  const client = useQueryClient()

  return useMutation({
    mutationFn: (actionId: string) => deleteAction({plantId, actionId}),
    onSuccess: () => {
      void client.invalidateQueries({queryKey: [QueryKeyName.GetActionItems]})
      spawnSuccessToast(t('deleteAction.afterSubmit.success'))
    },
    onError: () => {
      spawnErrorToast(t('deleteAction.afterSubmit.error'))
    }
  })
}
